(function () {
  const DUO_ROOT = '[data-ease-cart-duo]';
  const DUO_WRAP = '[data-ease-cart-duo-wrap]';
  const EMPTY_ROOT = '[data-ease-cart-empty]';
  const DUO_REVEAL_MS = 2000;
  const DUO_STORAGE_KEY = 'ease_cart_duo_state';
  /* Nur für die aktuelle Drawer-Öffnung */
  let duoKeepExpanded = false;
  let duoDeclinedThisOpen = false;

  /* Alte Session-Flags räumen — sonst bleibt die Frage weg */
  try {
    sessionStorage.removeItem(DUO_STORAGE_KEY);
  } catch (e) {
    /* ignore */
  }

  function expandDuoOffer(duo) {
    if (!duo) return;
    const gate = duo.querySelector('[data-ease-cart-duo-gate]');
    const offer = duo.querySelector('[data-ease-cart-duo-offer]');
    duo.classList.add('is-expanded');
    if (gate) {
      gate.setAttribute('hidden', '');
      gate.hidden = true;
    }
    if (offer) {
      offer.removeAttribute('hidden');
      offer.hidden = false;
    }
    const wrap = duo.closest(DUO_WRAP);
    if (wrap) wrap.classList.add('is-expanded');
    duoKeepExpanded = true;
    duoDeclinedThisOpen = false;
  }

  function collapseDuoToGate(duo) {
    if (!duo) return;
    const gate = duo.querySelector('[data-ease-cart-duo-gate]');
    const offer = duo.querySelector('[data-ease-cart-duo-offer]');
    duo.classList.remove('is-expanded');
    if (gate) {
      gate.removeAttribute('hidden');
      gate.hidden = false;
    }
    if (offer) {
      offer.setAttribute('hidden', '');
      offer.hidden = true;
    }
    const wrap = duo.closest(DUO_WRAP);
    if (wrap) wrap.classList.remove('is-expanded');
  }

  function dismissDuo(wrap) {
    if (!wrap) return;
    duoDeclinedThisOpen = true;
    duoKeepExpanded = false;
    wrap.classList.remove('is-revealed', 'is-expanded');
    wrap.classList.add('is-dismissed');
    if (wrap._easeRevealTimer) {
      clearTimeout(wrap._easeRevealTimer);
      wrap._easeRevealTimer = null;
    }
  }

  function getMoneyFormat(root) {
    const fromRoot = root?.getAttribute?.('data-money-format');
    if (fromRoot) return fromRoot;
    const fromDrawer = root?.closest?.('[data-ease-money-format]')?.getAttribute('data-ease-money-format');
    if (fromDrawer) return fromDrawer;
    return (
      window.FoxTheme?.settings?.moneyFormat ||
      window.theme?.moneyFormat ||
      window.Shopify?.money_format ||
      null
    );
  }

  function formatMoney(cents, format) {
    const moneyFormat = format || getMoneyFormat(document.querySelector(DUO_ROOT) || document.querySelector(EMPTY_ROOT));
    if (window.EaseMoney && typeof window.EaseMoney.format === 'function') {
      return window.EaseMoney.format(cents, moneyFormat);
    }
    if (window.EaseMoney && typeof window.EaseMoney.renderMoneyFormat === 'function') {
      return window.EaseMoney.renderMoneyFormat(cents, moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function bundleSections() {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    return sectionsToBundle;
  }

  async function addVariantToCart(variantId) {
    const sections = bundleSections();
    const addUrl = window.FoxTheme?.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
    const cartUrl = window.FoxTheme?.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart.js`;
    const fetchConfig = window.FoxTheme?.utils?.fetchConfig
      ? window.FoxTheme.utils.fetchConfig('javascript')
      : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        };

    const response = await fetch(addUrl, {
      ...fetchConfig,
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections,
        sections_url: window.location.pathname,
      }),
    });

    const parsedState = await response.json();
    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || 'Konnte nicht hinzugefügt werden.');
    }

    const cartResponse = await fetch(cartUrl, window.FoxTheme?.utils?.fetchConfig?.() || { headers: { Accept: 'application/json' } });
    const cartJson = await cartResponse.json();
    cartJson.sections = parsedState.sections;

    if (!window.FoxTheme?.pubsub) return cartJson;

    window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'ease-cart-add',
      cart: cartJson,
    });

    return cartJson;
  }

  function getSelectedVariantControl(duo) {
    return (
      duo.querySelector('.ease-cart-duo__swatch-btn.is-selected') ||
      duo.querySelector('[data-ease-cart-duo-variant]')
    );
  }

  function getVariantId(control) {
    if (!control) return 0;
    return parseInt(control.getAttribute('data-variant-id') || control.value, 10) || 0;
  }

  function updateDuoPrice(duo, control) {
    const nowEl = duo.querySelector('[data-ease-cart-duo-now]');
    const saveTotalEl = duo.querySelector('[data-ease-cart-duo-save-total]');
    if (!nowEl || !control) return;

    const firstUnit = parseInt(duo.getAttribute('data-first-unit-cents'), 10) || 0;
    const secondUnit = parseInt(control.getAttribute('data-unit-cents'), 10) || 0;
    const percent = parseInt(duo.getAttribute('data-discount-percent'), 10) || 0;
    const orderBefore = firstUnit + secondUnit;
    const saveCents = Math.round((orderBefore * percent) / 100);
    const orderAfter = Math.max(0, orderBefore - saveCents);
    const extraCents = Math.max(0, orderAfter - firstUnit);
    const hasDiscount = saveCents > 0;

    const moneyFormat = getMoneyFormat(duo);
    nowEl.textContent = `+ ${formatMoney(extraCents, moneyFormat)}`;

    if (saveTotalEl) {
      saveTotalEl.hidden = !hasDiscount;
      if (hasDiscount) saveTotalEl.textContent = `Spare ${formatMoney(saveCents, moneyFormat)}`;
    }

    const imageUrl = control.getAttribute('data-image-url');
    const img = duo.querySelector('[data-ease-cart-duo-img]');
    if (imageUrl && img) {
      img.src = imageUrl;
    }
  }

  function resetDuoReveal(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-revealed');
    if (wrap._easeRevealTimer) {
      clearTimeout(wrap._easeRevealTimer);
      wrap._easeRevealTimer = null;
    }
  }

  function scheduleDuoReveal(drawer) {
    const wrap = drawer?.querySelector(DUO_WRAP);
    if (!wrap) {
      duoKeepExpanded = false;
      return;
    }

    wrap.classList.remove('is-dismissed');

    if (duoDeclinedThisOpen) {
      dismissDuo(wrap);
      return;
    }

    const duo = wrap.querySelector(DUO_ROOT);
    if (duoKeepExpanded && duo) {
      expandDuoOffer(duo);
      wrap.classList.add('is-revealed');
      return;
    }

    if (duo) collapseDuoToGate(duo);

    if (wrap.classList.contains('is-revealed')) return;

    resetDuoReveal(wrap);
    wrap._easeRevealTimer = window.setTimeout(() => {
      wrap.classList.add('is-revealed');
      wrap._easeRevealTimer = null;
    }, DUO_REVEAL_MS);
  }

  function handleDuoGateClick(event) {
    const yesBtn = event.target.closest('[data-ease-cart-duo-yes]');
    const noBtn = event.target.closest('[data-ease-cart-duo-no]');
    if (!yesBtn && !noBtn) return;

    const duo = event.target.closest(DUO_ROOT);
    if (!duo) return;

    event.preventDefault();
    event.stopPropagation();

    if (yesBtn) {
      expandDuoOffer(duo);
      return;
    }

    dismissDuo(duo.closest(DUO_WRAP));
  }

  function getSelectedEmptyVariantControl(root) {
    return (
      root.querySelector('.ease-cart-empty__swatch-btn.is-selected') ||
      root.querySelector('[data-ease-cart-empty-variant]')
    );
  }

  function updateEmptyPrice(root, control) {
    const priceEl = root.querySelector('[data-ease-cart-empty-price]');
    if (!priceEl || !control) return;

    const unitCents = parseInt(control.getAttribute('data-unit-cents'), 10) || 0;
    priceEl.textContent = formatMoney(unitCents, getMoneyFormat(root));

    const imageUrl = control.getAttribute('data-image-url');
    const img = root.querySelector('[data-ease-cart-empty-img]');
    if (imageUrl && img) {
      img.src = imageUrl;
    }
  }

  function handleEmptySwatchClick(event) {
    const btn = event.target.closest('.ease-cart-empty__swatch-btn');
    if (!btn) return;

    const root = btn.closest(EMPTY_ROOT);
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();

    root.querySelectorAll('.ease-cart-empty__swatch-btn').forEach((swatch) => {
      const selected = swatch === btn;
      swatch.classList.toggle('is-selected', selected);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    updateEmptyPrice(root, btn);
  }

  async function handleEmptyAddClick(event) {
    const btn = event.target.closest('[data-ease-cart-empty-btn]');
    if (!btn) return;

    const root = btn.closest(EMPTY_ROOT);
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();

    const selected = getSelectedEmptyVariantControl(root);
    const variantId = getVariantId(selected);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      await addVariantToCart(variantId);
    } catch (error) {
      console.error('ease-cart-empty:', error);
      alert(error.message || 'Konnte nicht hinzugefügt werden.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  function handleDuoSwatchClick(event) {
    const btn = event.target.closest('.ease-cart-duo__swatch-btn');
    if (!btn) return;

    const duo = btn.closest(DUO_ROOT);
    if (!duo) return;

    event.preventDefault();
    event.stopPropagation();

    duo.querySelectorAll('.ease-cart-duo__swatch-btn').forEach((swatch) => {
      const selected = swatch === btn;
      swatch.classList.toggle('is-selected', selected);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    updateDuoPrice(duo, btn);
  }

  async function handleDuoClick(event) {
    const btn = event.target.closest('[data-ease-cart-duo-btn]');
    if (!btn) return;

    const duo = btn.closest(DUO_ROOT);
    if (!duo) return;

    event.preventDefault();
    event.stopPropagation();

    const selected = getSelectedVariantControl(duo);
    const variantId = getVariantId(selected);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      await addVariantToCart(variantId);
    } catch (error) {
      console.error('ease-cart-duo:', error);
      alert(error.message || 'Konnte nicht hinzugefügt werden.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  async function fetchCart() {
    const cartUrl = window.FoxTheme?.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart.js`;
    const response = await fetch(cartUrl, window.FoxTheme?.utils?.fetchConfig?.() || { headers: { Accept: 'application/json' } });
    return response.json();
  }

  function normalizeLineProperties(item) {
    const properties = {};
    if (!item?.properties) return properties;
    Object.keys(item.properties).forEach((key) => {
      const value = item.properties[key];
      if (value != null && value !== '') {
        properties[key] = value;
      }
    });
    return properties;
  }

  function findCartItem(cart, line, lineKey) {
    if (!cart?.items?.length) return null;
    if (lineKey) {
      return cart.items.find((item) => item.key === lineKey) || null;
    }
    const lineNum = parseInt(line, 10);
    if (!lineNum) return null;
    return cart.items[lineNum - 1] || null;
  }

  async function publishCartUpdate(cartJson, sections) {
    if (sections) {
      cartJson.sections = sections;
    }

    if (!window.FoxTheme?.pubsub) return cartJson;

    window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'ease-cart-upgrade',
      cart: cartJson,
    });

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cartJson },
      })
    );

    return cartJson;
  }

  function isCartApiError(parsedState) {
    if (!parsedState || parsedState.status) return true;
    if (!parsedState.errors) return false;
    if (typeof parsedState.errors === 'string') return parsedState.errors.length > 0;
    return Object.keys(parsedState.errors).length > 0;
  }

  function getCartApiErrorMessage(parsedState, fallback) {
    if (!parsedState) return fallback;
    if (typeof parsedState.description === 'string' && parsedState.description) return parsedState.description;
    if (typeof parsedState.message === 'string' && parsedState.message) return parsedState.message;
    if (typeof parsedState.errors === 'string' && parsedState.errors) return parsedState.errors;
    return fallback;
  }

  async function changeCartLine(line, quantity, options = {}) {
    const sections = bundleSections();
    const changeUrl = window.FoxTheme?.routes?.cart_change_url || `${window.Shopify?.routes?.root || '/'}cart/change.js`;
    const fetchConfig = window.FoxTheme?.utils?.fetchConfig
      ? window.FoxTheme.utils.fetchConfig()
      : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        };

    const payload = {
      quantity: parseInt(quantity, 10),
      sections,
      sections_url: window.location.pathname,
    };

    if (options.lineKey) {
      payload.id = String(options.lineKey);
    } else {
      payload.line = parseInt(line, 10);
    }

    if (options.properties && typeof options.properties === 'object') {
      payload.properties = options.properties;
    }

    const response = await fetch(changeUrl, {
      ...fetchConfig,
      body: JSON.stringify(payload),
    });

    const parsedState = await response.json();
    if (isCartApiError(parsedState)) {
      throw new Error(getCartApiErrorMessage(parsedState, 'Upgrade fehlgeschlagen.'));
    }

    return parsedState;
  }

  async function updateCartVariants(updates) {
    const sections = bundleSections();
    const updateUrl = window.FoxTheme?.routes?.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update.js`;
    const fetchConfig = window.FoxTheme?.utils?.fetchConfig
      ? window.FoxTheme.utils.fetchConfig()
      : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        };

    const response = await fetch(updateUrl, {
      ...fetchConfig,
      body: JSON.stringify({
        updates,
        sections,
        sections_url: window.location.pathname,
      }),
    });

    const parsedState = await response.json();
    if (isCartApiError(parsedState)) {
      throw new Error(getCartApiErrorMessage(parsedState, 'Upgrade fehlgeschlagen.'));
    }

    return parsedState;
  }

  async function upgradeCartLineVariant({ line, lineKey, variantId, quantity }) {
    const cart = await fetchCart();
    const item = findCartItem(cart, line, lineKey);
    if (!item) {
      throw new Error('Artikel im Warenkorb nicht gefunden.');
    }

    const essentialVariantId = String(item.variant_id);
    const premiumVariantId = String(variantId);
    const qty = parseInt(quantity, 10) || item.quantity || 1;
    const properties = normalizeLineProperties(item);
    properties._ease_tier = 'premium';

    const parsedState = await updateCartVariants({
      [essentialVariantId]: 0,
      [premiumVariantId]: qty,
    });

    const premiumItem = (parsedState.items || []).find(
      (cartItem) => String(cartItem.variant_id) === premiumVariantId
    );

    if (premiumItem && Object.keys(properties).length) {
      try {
        await changeCartLine(null, qty, {
          lineKey: premiumItem.key,
          properties,
        });
      } catch (error) {
        console.warn('ease-cart-upgrade: property update failed', error);
      }
    }

    const cartJson =
      premiumItem && Object.keys(properties).length ? await fetchCart() : parsedState;
    return publishCartUpdate(cartJson, parsedState.sections);
  }

  async function upgradeCartLineProperties({ line, lineKey, quantity, tier }) {
    const cart = await fetchCart();
    const item = findCartItem(cart, line, lineKey);
    if (!item) {
      throw new Error('Artikel im Warenkorb nicht gefunden.');
    }

    const properties = normalizeLineProperties(item);
    properties._ease_tier = tier;

    const parsedState = await changeCartLine(line, quantity || item.quantity, {
      lineKey: item.key,
      properties,
    });

    const cartJson = await fetchCart();
    return publishCartUpdate(cartJson, parsedState.sections);
  }

  async function handleUpgradeClick(event) {
    const btn = event.target.closest('[data-ease-cart-upgrade]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const line = btn.getAttribute('data-line');
    const lineKey = btn.getAttribute('data-line-key');
    const variantId = btn.getAttribute('data-variant-id');
    const quantity = btn.getAttribute('data-quantity') || '1';
    const upgradeMode = btn.getAttribute('data-upgrade-mode');
    const tier = btn.getAttribute('data-tier');
    if (!line && !lineKey) return;
    if (upgradeMode !== 'property' && !variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      if (upgradeMode === 'property' && tier) {
        await upgradeCartLineProperties({ line, lineKey, quantity, tier });
      } else {
        await upgradeCartLineVariant({ line, lineKey, variantId, quantity });
      }
    } catch (error) {
      console.error('ease-cart-upgrade:', error);
      alert(error.message || 'Upgrade fehlgeschlagen.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  function initDrawer(drawer) {
    const duo = drawer.querySelector(DUO_ROOT);
    const wrap = drawer.querySelector(DUO_WRAP);
    if (wrap) resetDuoReveal(wrap);

    if (duo) {
      const selected = getSelectedVariantControl(duo);
      if (selected) updateDuoPrice(duo, selected);
    }

    const empty = drawer.querySelector(EMPTY_ROOT);
    if (empty) {
      const selectedEmpty = getSelectedEmptyVariantControl(empty);
      if (selectedEmpty) updateEmptyPrice(empty, selectedEmpty);
    }
  }

  function boot() {
    document.querySelectorAll('cart-drawer.ease-cart-drawer').forEach((drawer) => {
      initDrawer(drawer);
      if (drawer.open) {
        scheduleDuoReveal(drawer);
      }
    });
  }

  document.addEventListener('click', handleDuoGateClick);
  document.addEventListener('click', handleDuoClick);
  document.addEventListener('click', handleDuoSwatchClick);
  document.addEventListener('click', handleEmptyAddClick);
  document.addEventListener('click', handleEmptySwatchClick);
  document.addEventListener('click', handleUpgradeClick);

  document.addEventListener('drawer:handleAfterShow', (event) => {
    const drawer = event.target.closest('cart-drawer.ease-cart-drawer');
    if (drawer) scheduleDuoReveal(drawer);
  });

  document.addEventListener('drawer:handleAfterHide', (event) => {
    const drawer = event.target.closest('cart-drawer.ease-cart-drawer');
    if (!drawer) return;
    const wrap = drawer.querySelector(DUO_WRAP);
    duoKeepExpanded = false;
    duoDeclinedThisOpen = false;
    if (wrap) {
      wrap.classList.remove('is-expanded', 'is-dismissed');
      const duo = wrap.querySelector(DUO_ROOT);
      if (duo) collapseDuoToGate(duo);
      resetDuoReveal(wrap);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', boot);
})();
